import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Floating action bar shown while rows are selected; stays reachable while scrolling long lists. */
export function SelectionBar({ count, onClear, children }: { count: number; onClear: () => void; children: React.ReactNode }) {
  if (count === 0) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-30 flex justify-center px-4 pb-[max(1rem,env(safe-area-inset-bottom))] max-sm:bottom-14">
      <div
        role="toolbar"
        aria-label="Auswahl"
        className="pointer-events-auto flex max-w-full flex-wrap items-center gap-2 rounded-xl bg-popover px-3 py-2 text-sm text-popover-foreground shadow-lg ring-1 ring-border motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-bottom-2 motion-safe:duration-150"
      >
        <span className="px-1 tabular-nums">{count} ausgewählt</span>
        {children}
        <Button variant="ghost" size="icon-sm" aria-label="Auswahl aufheben" onClick={onClear}><X /></Button>
      </div>
    </div>
  );
}
